import * as SendBird from 'sendbird';
import * as shortid from 'shortid';

let instance: SendBirdConnection | null = null;

export default class SendBirdConnection {
  public onReconnectStarted: SendBird.ConnectionHandler['onReconnectStarted'] | null = null;
  public onReconnectSucceeded: SendBird.ConnectionHandler['onReconnectSucceeded'] | null = null;
  public onReconnectFailed: SendBird.ConnectionHandler['onReconnectFailed'] | null = null;

  private _sb = SendBird.getInstance();
  private _key = shortid.generate();

  public static getInstance() {
    return instance;
  }

  constructor() {
    if (instance) {
      return instance;
    }

    this._createConnectionHandler();
    instance = this;
  }

  public remove() {
    this._sb.removeConnectionHandler(this._key);
  }

  /**
   * Connection Handler
   */
  private _createConnectionHandler() {
    const handler = new this._sb.ConnectionHandler();

    handler.onReconnectStarted = () => {
      if (this.onReconnectStarted) {
        this.onReconnectStarted();
      }
    };

    handler.onReconnectSucceeded = () => {
      if (this.onReconnectSucceeded) {
        this.onReconnectSucceeded();
      }
    };

    handler.onReconnectFailed = () => {
      if (this.onReconnectFailed) {
        this.onReconnectFailed();
      }
    };

    this._sb.addConnectionHandler(this._key, handler);
  }
}



// WEBPACK FOOTER //
// ./src/services/sb/SendBirdConnection.ts